import { apiGet } from 'helpers/ApiHelper';
import Auth from 'j-toker';

export function getCotenant(cotenantId) {
  return apiGet(`${Auth.getApiUrl()}/leads/application_portal/cotenants/${cotenantId}`);
}

export function getTodos(cotenantId) {
  return apiGet(`${Auth.getApiUrl()}/leads/application_portal/cotenants/${cotenantId}/todos`);
}

export function getDocuments(cotenantId) {
  return apiGet(`${Auth.getApiUrl()}/leads/application_portal/cotenants/${cotenantId}/documents`);
}
